import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TablerIconComponent } from 'angular-tabler-icons';

@Component({
  selector: 'app-tabs-buttons',
  templateUrl: './tabs-buttons.component.html',
  styleUrls: ['./tabs-buttons.component.scss'],
  imports: [
    CommonModule,
    TablerIconComponent
  ]
})
export class TabsButtonsComponent {
  
  @Input() buttons: any[] = [];
  @Input() selectedButton: any;
  @Output() selectedButtonChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}

  selectButton(button: any) {
    this.selectedButton = button;
    this.selectedButtonChange.emit(this.selectedButton);
  }
}